import { Component, OnInit, Input } from '@angular/core';
import { SetService, JwtService, HttpService, GeneralPipe, FormControlService } from 'ngx-block-core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  PDFDocumentProxy,
} from 'ng2-pdf-viewer';
import { NzMessageService } from 'ng-zorro-antd';
import * as XLSX from 'xlsx';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as fs from 'file-saver';
@Component({
  selector: 'app-sucu01-data0010002',
  templateUrl: './sucu01-data0010002.component.html',
  styleUrls: ['./sucu01-data0010002.component.less'],
})




export class Sucu01Data0010002Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";

  @Input() sets = {
    blockCode: "sucublock51",
    blockId: "",
    blockName: "定制表格",
    layoutId: "",
    blockType: "table",
    blockChildType: '',
    versionCode: 7,
    attributes: [],
    events: [


    ],
    styles: {
      nzMode: "table",//pdf
      nzPdfSets: {
        title: "",//"SIC",
        srcs: [
          "../../../../../../assets/Lodop.pdf",
          "../../../../../../assets/play.pdf"
        ],
      },
      nzPageSizeOptions: [50, 100, 200, 300, 500],
      nzPageSize: 20,
      color: {
        "1": "#F0F0F0",
        "2": "#E0E0E0",
        "0": null
      }
    },
    datas: {
      nzTableName: "",
      nzFormLayoutId: ""
    }
  };
  setData = []
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzCustomTable' },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'color',
                inputs: {
                  nzText: "标注颜色 : ", nzKeys: ['styles', 'color', '1']
                }
              },
              {
                name: 'color',
                inputs: {
                  nzText: "标注颜色2 : ", nzKeys: ['styles', 'color', '2']
                }
              },
              {
                name: 'select',
                inputs: {
                  nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: [
                    { value: "table", label: "定制表格" },
                    { value: "pdf", label: "PDF预览" },
                    { value: "child", label: "主从表格" },
                  ]
                },

              },
              {
                name: 'input',
                inputs: {
                  nzText: "pdf弹框标题 : ", nzKeys: ['styles', 'nzPdfSets', 'title']
                }
              },
              {
                name: 'nzPageSizeOptions',
              },
            ]
          },


        ]
      },

    ]
  }
  constructor(private fb: FormBuilder, public setService: SetService,
    private http: HttpService,
    private generalPipe: GeneralPipe,
    private jwtService: JwtService,
    private formControlService: FormControlService,
    private message: NzMessageService) { }
  widthConfig = [];
  scrollConfig = { x: '1500px' };
  listOfDisplayData: any[] = [];
  pageData: any[] = [];
  listOfData: any[] = [];


  /** 导出数据组
   * 
   * 
   * 
  */
  exportHead = [];
  exportHeadJson = {};
  exportHeadJsonList = [];
  exportHeadLength = {
    height: 0,
    width: 0
  }

  gorupdata = {}
  colorIndex = 0
  getDataColumn2() {

    let data = {
      already_index: [],//已登记的index
      able_block: [],//index的可用区域
      column_sort: {},//字段的排序
    }
    let column_ength = 0;


    let expandGroup = {}, groupid = 0, startid = 0, havegroup = false;
    /** 导出处理 start*/
    this.exportHead = [];
    this.exportHeadJson = {};
    this.exportHeadJsonList = [];
    this.exportHeadLength = {
      height: this.nzGroupTr.length,
      width: 0
    }
    /** 导出处理 end*/
    for (let index = 0; index < this.nzGroupTr.length; index++) {
      const rowData = this.nzGroupTr[index];//行数据

      /** 导出处理 start*/
      this.exportHead.push([]);
      /** 导出处理 end*/

      for (let j = 0; j < rowData.length; j++) {

        const columnData = rowData[j];//列数据

        /** 导出处理 start*/
        if (index == 0)
          this.exportHeadLength.width = this.exportHeadLength.width + columnData.colspan;
        /** 导出处理 end*/

        if (columnData.showName == "") {
          columnData.columnName = groupid;
        }
        this.columnData[columnData.columnName] = {
          showLength: columnData.showName.length,
          nzLeft: null,
          nzRight: null,
          nzBgColor: this.sets.styles.color[columnData.nzBgColor],
          nzExpand: {
            value: true,
            nzUsed: false,
            nzExpand: false,
            nzGroupId: "",
          }

        }
        if (columnData.rowspan + index == this.nzGroupTr.length) {
          //直接到底，最小列
          column_ength++;
          data.column_sort[columnData.columnsort - 1] = columnData.columnName;
        }
        //收展统计
        if (index == 0) {
          if (columnData.showName == "") {
            if (typeof expandGroup[groupid] == "undefined") {
              expandGroup[groupid] = {
                number: 1
              }
            } else {
              expandGroup[groupid]['number']++;
            }
            this.columnData[columnData.columnName]['nzExpand']['nzGroupId'] = groupid;
            this.columnData[columnData.columnName]['nzExpand']['value'] = false;
            const filtersindex = this.filters.indexOf(columnData.columnName)
            if (filtersindex < 0)
              this.filters.push(columnData.columnName)
            havegroup = true;
          }
          if (columnData.colspan != 1 && havegroup == true) {
            havegroup = false
            this.columnData[columnData.columnName]['nzExpand']['nzGroupId'] = groupid++;
            this.columnData[columnData.columnName]['nzExpand']['nzUsed'] = true;

            console.log("expandGroup", groupid, expandGroup[groupid - 1]['number'])
          }
        } else if (index == 1) {
          console.log("expandGroup", startid, expandGroup[startid]['number'], columnData.columnName)
          if (expandGroup[startid]['number'] > 0) {
            this.columnData[columnData.columnName]['nzExpand']['nzGroupId'] = startid;
            this.columnData[columnData.columnName]['nzExpand']['value'] = false;
            const filtersindex = this.filters.indexOf(columnData.columnName)
            if (filtersindex < 0)
              this.filters.push(columnData.columnName)
            expandGroup[startid]['number']--;
          } else {
            expandGroup[startid]['number']--;
            if (expandGroup[startid]['number'] == -2 && startid < groupid - 1) {
              startid++;
            }
          }
        }
      }
    }
    for (let index = 0; index < column_ength; index++) {
      this.dataColumn.push(data.column_sort[index])
      let headItem = {
        key: data.column_sort[index],
        width: 10,
      }
      let thisColumnData = this.columnData[data.column_sort[index]];
      console.log("thisColumnData", data.column_sort[index], thisColumnData['nzExpand']['nzGroupId'], thisColumnData['nzExpand']['nzUsed'], thisColumnData['nzExpand']['nzGroupId'] != '' && !thisColumnData['nzExpand']['nzUsed'])
      if (thisColumnData['nzExpand']['nzGroupId'] !== '' && !thisColumnData['nzExpand']['nzUsed']) {
        console.log("ColumnData2", data.column_sort[index])

        headItem['outlineLevel'] = 1;
      }
      if (index == column_ength - 1) headItem.width = 80;
      this.exportHeadJsonList.push(headItem)
      this.widthConfig.push(null);
      // console.log("index", this.columnData, index)
      if (index == 0) {
        this.columnData[data.column_sort[index]]['nzLeft'] = '0px';
        this.widthConfig[0] = "100px"

      } else if (index == 1 && this.widthConfig[0] != null) {
        this.columnData[data.column_sort[index]]['nzLeft'] = this.widthConfig[0];
      }
      else if (index == column_ength - 1) {
        // this.columnData[data.column_sort[index]]['nzRight'] = '0px';
        // this.widthConfig[column_ength-1]="100px"
      }

    }
    this.scrollConfig = { x: (column_ength * 80) + 'px' };
    console.log("getDataColumn columnData", this.columnData)

    console.log("getDataColumn", data, this.dataColumn, this.scrollConfig)
    this.allDataColumn = [...this.dataColumn]

    //过滤dataColumn
    console.log("this.filters", this.filters.length, this.filters)

    this.dataColumn = this.allDataColumn.filter(value => this.filters.indexOf(value) < 0)
    console.log("this.dataColumn", this.dataColumn.length, this.dataColumn)
    this.scrollConfig = { x: (this.dataColumn.length * 80) + 'px' };
  }

  columnData = {};
  dataColumn = []
  allDataColumn = []
  nzGroupTr = [
  ];

  ngOnInit() {
    this.baseInit();
    if (this.sets.styles.nzMode == "table") this.getHead();
    else if (this.sets.styles.nzMode == "pdf") {
      this.sets.styles.nzPdfSets.srcs.forEach(element => {
        this.pdfSrcs.push(element)
      });

      this.pdfSrc = this.pdfSrcs[this.pdfIndex];

    } else if (this.sets.styles.nzMode == "child") {
      this.sets.styles.nzPageSize = 20;
      this.searchData_child();
    }
    console.log('initFrom', this.pdfSrc, this.pdfSrcs, this.sets.styles.nzPdfSets.srcs)
    this.initFrom();
    this.Listening();

  }

  pdfMousewheel(event) {
    console.log(event);
    try {
      if (event.wheelDelta > 0) { //当滑轮向上滚动时
        this.incrementZoom(0.05);
        // alert("滑轮向上滚动");
      }
      else if (event.wheelDelta < 0) { //当滑轮向下滚动时
        // alert("滑轮向下滚动");
        this.incrementZoom(-0.05);
      }
      event.cancelBubble = true;
      event.returnValue = false;
    } catch (error) {

    }
    // return;
  }
  autoUpdate() {

    //v2
    if (this.sets.versionCode < 2) {
      this.sets.styles.color =
      {
        "1": "#F0F0F0",
        "2": "#E0E0E0",
        "0": null
      }

      this.sets.versionCode = 2;
    }
    //v2
    if (this.sets.versionCode < 3) {
      this.sets.styles.nzMode = "table";
      this.sets.styles.nzPdfSets = {
        title: "",
        srcs: [""],
      }

      this.sets.versionCode = 3;
    }

    if (this.sets.versionCode < 5) {
      this.sets.styles.nzPageSizeOptions = [50, 100, 200, 300, 500];

      this.sets.versionCode = 5;
    }
    if (this.sets.versionCode < 6) {
      this.sets.datas.nzFormLayoutId = "";
      this.sets.versionCode = 6;
    }
    if (this.sets.versionCode < 7) {

      this.sets.styles.nzPageSize = 20;
      this.sets.versionCode = 7;
    }

  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
          console.log("json", JSON.stringify(this.sets))
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.autoUpdate()
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()

      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
        this.autoUpdate()
      }
    }

  }

  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {

          default:
            break;
        }
      }
      )
    }, 100);

  }
  ngOnDestroy() {
    console.log("ngOnDestroy注销");
    this.setService.deleteEvent(this.blockid);
    if (!this.static)
      this.setService.deleteEvent(this.blockid, 'pz')
  }
  searchMap = {}
  /** 搜索后，需执行的事件 */
  searchEvent = {};
  Listening() {
    setTimeout(() => {
      console.log("ListeningINIT:", this.blockid);

      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("Listening:", this.blockid, data['type'], JSON.stringify(data));
          switch (data['type']) {
            case 'search':
              this.searchEvent = {};
              if (typeof data['sets'] != "undefined" && data['sets'] != "") {

                const setArr = (data['sets'] + "").split(",")
                setArr.forEach(element => {
                  switch (element) {
                    case "checkall":
                      this.searchEvent[element] = true
                      break;

                    default:
                      break;
                  }
                });

              }
              this.searchMap = data['datas'];
              if (typeof data['status'] != "undefined")
                this.searchData(false, this.searchMap, data['status'], this.searchEvent);
              else
                this.searchData(false, this.searchMap, { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, this.searchEvent);
              break;
            case 'showPdf':
              this.resId = data.datas
              console.log("this.pdfSrcs:", this.pdfSrcs);
              // this.pdfSrc = this.pdfSrcs[this.pdfIndex];
              this.isVisible = true;
              break;
            case 'showPdfbyFiles':
              this.showPdfByFiles(data.datas.datas);
              break;
            case 'export':
              this.exportExcel(data['datas'])
              break;
            default:
              break;
          }
        }
      )
    }, !this.static ? 100 : 0);


  }
  /**资源id */
  resId = ""
  nzTotal = 1;
  loading = false;
  searchDataPage(page) {
    console.log('searchDataPage', page, this.pageIndex);
    this.pageIndex = page;
    this.searchData();
  }
  searchDataPageSize(size) {
    console.log('earchDataPageSize', size);
    this.sets.styles.nzPageSize = size;
    this.searchData();
  }
  searchData_child(isExport: boolean = false, searchMap?, status = { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, eventData?) {
    if (typeof searchMap == "undefined") searchMap = JSON.parse(JSON.stringify(this.searchMap));
    let bodys = {
      // "tableColumn": [],
      "tableName": this.sets['datas']['nzTableName'],
      "pageSize": this.sets.styles.nzPageSize,
      "nowPage": this.pageIndex,
      "tableSort": [],
      "searchMap": searchMap,
      'engineMap': {}
    }
    if (isExport) {
      bodys.pageSize = 0;
    }
    console.log("body", this.pageIndex, JSON.stringify(bodys))
    this.loading = true;
    this.http.postHttp("http://localhost:8080/barcodematerial/child", bodys).subscribe(

      (data: any) => {
        this.loading = false;
        this.isNewData = true;
        console.log("tableData", data)

        this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName, 1);

      },
      (err: any) => {
        this.loading = false;

      })
  }
  searchData(isExport: boolean = false, searchMap?, status = { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, eventData?) {
    if (this.sets.styles.nzMode == "child") {
      return this.searchData_child(isExport, searchMap, status, eventData);
    }
    if (typeof searchMap == "undefined") searchMap = JSON.parse(JSON.stringify(this.searchMap));
    let bodys = {
      // "tableColumn": [],
      "tableName": this.sets['datas']['nzTableName'],
      "pageSize": this.sets.styles.nzPageSize,
      "nowPage": this.pageIndex,
      "tableSort": [],
      "searchMap": searchMap,
      'engineMap': {}
    }
    if (isExport) {
      bodys.pageSize = 0;
    }
    console.log("body", this.pageIndex, JSON.stringify(bodys))
    this.loading = true;
    // this.http.postHttpAllUrl("http://localhost:8080/wipReport/tableData", bodys).subscribe(
    // this.http.postHttp("/wipReport/tableData?size=" + this.sets['styles']['nzPageSize'] + "&page=" + this.pageIndex, bodys).subscribe(
    this.http.postHttp("/wipReport/tableData", bodys).subscribe(

      (data: any) => {
        this.loading = false;
        this.isNewData = true;
        console.log("tableData", data)
        // this.listOfDisplayData = data.data;
        this.listOfDisplayData = data.data['list'];
        if (!isExport) {
          this.pageData = data.data['list'];
          this.nzTotal = data.data['total'];
        } else {
          this.export2();
          this.setService.sendEvent(eventData.blockid, 'nzLoadingOk');

        }
        console.log("tableData-nzTotal", this.nzTotal)
        this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName, 1);

      },
      (err: any) => {
        this.loading = false;
        if (isExport) {
          this.setService.sendEvent(eventData.blockid, 'nzLoadingOk');

        }
      })

  }
  getHead() {
    // this.http.getHttpAllUrl("http://localhost:8080/wipReport/tableHead").subscribe(
    this.http.getHttp("/wipReport/tableHead").subscribe(
      (data: any) => {
        console.log("getHead", data.data)
        this.nzGroupTr = data.data[0]
        this.getDataColumn2();
      })
  }
  pageIndex = 1;
  filters = []
  expand(columnName, defaultvalue?) {
    const groupid = this.columnData[columnName]['nzExpand'].nzGroupId
    if (defaultvalue == undefined) {
      this.columnData[columnName]['nzExpand']['nzExpand'] = !this.columnData[columnName]['nzExpand']['nzExpand']
    } else {
      this.columnData[columnName]['nzExpand']['nzExpand'] = defaultvalue;
    }

    console.log("groupid", groupid, this.columnData[columnName])
    for (const key in this.columnData) {
      if (this.columnData.hasOwnProperty(key)) {
        const element = this.columnData[key]['nzExpand'];
        console.log("groupid", element.nzGroupId, groupid, key)
        if (element.nzGroupId === groupid && !element.nzUsed) {


          if (defaultvalue == undefined) {
            //默认模式
            if (element.value) {
              //如果开了
              const index = this.filters.indexOf(key)
              if (index < 0)
                this.filters.push(key);
              console.log("filters push", this.filters.length, this.filters)
            } else {
              //如果关了
              const index = this.filters.indexOf(key)
              if (index >= 0) {
                this.filters.splice(index, 1);
                console.log("filters splice", index, this.filters)
              }

            }
            element.value = !element.value
          } else {
            //传值模式
            if (defaultvalue) {
              //true,展开，所有都不过滤
              const index = this.filters.indexOf(key)
              if (index >= 0) {
                this.filters.splice(index, 1);
                console.log("filters splice", index, this.filters)
              }
            } else {
              //false-关闭，所有都过滤
              const index = this.filters.indexOf(key)
              if (index < 0)
                this.filters.push(key);
              console.log("filters push", this.filters.length, this.filters)
            }
            element.value = defaultvalue;
          }

        }

      }
    }
    console.log("this.filters", this.filters.length, this.filters)
    //过滤dataColumn
    this.dataColumn = this.allDataColumn.filter(value => this.filters.indexOf(value) < 0)
    console.log("this.dataColumn", this.dataColumn.length, this.dataColumn)
    this.scrollConfig = { x: (this.dataColumn.length * 80) + 'px' };
  }
  //============================================================


  getDataColumn() {
    console.log("getDataColumn", 1)
    const head_height = this.nzGroupTr.length;
    let column_ength = 0;
    //统计columnlength
    for (let index = 0; index < head_height; index++) {
      const rowData = this.nzGroupTr[index];//行数据
      for (let j = 0; j < rowData.length; j++) {
        const columnData = rowData[j];//列数据
        this.columnData[columnData.columnName] = {
          nzLeft: null,
          nzRight: null,
          nzBgColor: this.sets.styles.color[columnData.nzBgColor]
        }
        if (columnData.rowspan + index == head_height) {//直接到底，最小列
          column_ength++;
        }

      }
    }


    let data = {
      already_index: [],//已登记的index
      able_block: [],//index的可用区域
      column_sort: {},//字段的排序
    }
    //登记可用坐标
    for (let index = 0; index < column_ength; index++) {
      data.able_block.push(index);
    }
    //
    for (let index = 0; index < head_height; index++) {
      const rowData = this.nzGroupTr[index];//行数据
      let sumIndex = data.able_block[0];//下标统计，从最小可用index开始
      console.log("getDataColumn", 'able_block', data.able_block, sumIndex)
      const already_index = [...data.already_index];
      for (let i = 0; i < already_index.length; i++) {
        if (already_index[i] < sumIndex) {
          already_index.splice(i, 1);
          i--;
        }

      }

      for (let j = 0; j < rowData.length; j++) {
        const columnData = rowData[j];//列数据
        this.columnData[columnData.columnName] = {
          nzLeft: null,
          nzRight: null,
          nzBgColor: this.sets.styles.color[columnData.nzBgColor]
        }
        //需判断是否跳区域
        const old = sumIndex;
        sumIndex = sumIndex + columnData.colspan;
        console.log("getDataColumn", 'old-sumIndex', old - 1, sumIndex - 1, already_index)
        for (let i = 0; i < already_index.length; i++) {
          if (already_index[i] > old - 1 && already_index[i] <= sumIndex - 1) {
            //计算连续区域长度
            let len = 1;
            already_index.splice(i, 1);
            for (let k = already_index[i]; k < column_ength; k++) { //7  2->12   8 9 10 14
              if (already_index.indexOf(k) >= 0) {
                len++;
                already_index.splice(already_index.indexOf(k), 1);
              } else {
                break;
              }
            }
            i--;
            console.log("getDataColumn", 'len', len, sumIndex, already_index)
            sumIndex = sumIndex + len;
          } else {
            // already_index.splice(i,1);
            // i--;
          }
        }
        console.log("getDataColumn", 'sumIndex', sumIndex - 1)
        if (columnData.rowspan + index == head_height) {//直接到底，最小列
          //判断是否跳区

          data.column_sort[sumIndex - 1] = columnData.columnName;
          data.already_index.push(sumIndex - 1)
          data.able_block.splice(data.able_block.indexOf(sumIndex - 1), 1)
          console.log("getDataColumn", 'deal', data.able_block, columnData.columnName, sumIndex - 1, data.already_index)

          data.already_index.sort(function (a, b) {

            return a - b;
          })
          // console.log("getDataColumn", 'sort', data.already_index)
        }
      }

    }
    // data.column_sort.
    console.log("getDataColumn", data)
    for (let index = 0; index < column_ength; index++) {
      this.dataColumn.push(data.column_sort[index])
      this.widthConfig.push(null)
      if (index == 0) {
        this.columnData[data.column_sort[index]]['nzLeft'] = '0px';
        this.widthConfig[0] = "80px"

      } else if (index == 1 && this.widthConfig[0] != null) {
        this.columnData[data.column_sort[index]]['nzLeft'] = this.widthConfig[0];
      }
      else if (index == column_ength - 1) {
        this.columnData[data.column_sort[index]]['nzRight'] = '0px';
        // this.widthConfig[column_ength-1]="100px"
      }

    }
    this.scrollConfig = { x: (column_ength * 80) + 'px' };
    console.log("getDataColumn columnData", this.columnData)

    console.log("getDataColumn", data, this.dataColumn, this.scrollConfig)
  }

  pdfSrc: string = '../../../../../../assets/Lodop.pdf';
  pdfIndex = 0;
  page = 1;
  showAll = false;
  pdf: any;
  pdfSrcs: any[] = [];
  outline: any[];
  isLoaded = false;
  showPdf = false;
  allPage = 0;
  onClickPage(page) {
    console.log("onClickPage1", this.page);
    this.page = this.page + page;
    console.log("onClickPage2", this.page);
  }
  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pdf = pdf;
    this.isLoaded = true;
    this.loadOutline();
  }
  onError(event) {
    console.log("onError", event);
    if (event.message == "Failed to fetch") {
      this.message.create('error', `未能获取文件`);
      this.isVisible = false;
      this.isLoaded = false;
      this.pdfIndex = 0;
      this.page = 1;
      this.pdfSrc = this.pdfSrcs[this.pdfIndex];
      this.showPdf = false;
    }

  }
  /**
   * Get outline
   */
  loadOutline() {
    this.pdf.getOutline().then((outline: any[]) => {
      this.outline = outline;
    });
  }
  closeView() {
    this.isVisible = false;
    this.isLoaded = false;

    console.log("this.pdfIndex1", this.pdfIndex)

    if (this.pdfIndex + 1 < this.pdfSrcs.length) {
      this.pdfIndex++;
      this.pdfSrc = this.pdfSrcs[this.pdfIndex];
      this.page = 1;
      this.isVisible = true;
      console.log("this.pdfIndex2", this.pdfIndex, this.pdfSrc)
    } else {
      this.pdfIndex = 0;
      this.page = 1;
      this.pdfSrc = this.pdfSrcs[this.pdfIndex];
      this.showPdf = false;
    }




  }

  //弹框
  isVisible = false;
  //表单
  validateForm: FormGroup;
  showPdfbyBUtton() {
    this.pdfSrc = "../../../../../../assets/Lodop.pdf"
    this.isVisible = true;
    this.showPdf = true;
  }
  showPdfByFiles(list) {
    this.pdfSrcs = [];
    list.forEach(element => {
      this.pdfSrcs.push(this.jwtService.getUserResourceUrl() + element.flag1)
      console.log("getUserResourceUrl", this.jwtService.getUserResourceUrl() + element.flag1)
    });
    this.pdfSrc = this.pdfSrcs[this.pdfIndex];
    // this.pdfSrc="../../../../../../assets/Lodop.pdf"
    this.isVisible = true;
    this.showPdf = true;
    console.log("pdfSrc", this.showPdf, this.pdfSrc)
  }
  submitForm(): void {
    let body = {
      "resourceId": this.resId,
      "productSn": this.validateForm.controls.sn.value
      //       "resourceId":"TS1",
      // "productSn":"HLMBM1801031909001821"
    }
    console.log("resourceProductSIC-body", body);
    // this.http.postHttp("http://172.16.8.106:81/cloudblock_lhoracle/businessVerification/resourceProductSIC", body).subscribe(
    this.http.postHttp("/businessVerification/resourceProductSIC", body).subscribe(
      (data: any) => {
        console.log("data.data", JSON.stringify(data))
        if (data.data.state == "success") {

          this.pdfSrcs = [];
          if (data.data.data.length == 0) {
            this.message.create('success', "无需阅读文件");
            this.closeView()
          } else {
            data.data.data.forEach(element => {
              this.pdfSrcs.push(this.jwtService.getUserResourceUrl() + element.flag1)
              console.log("getUserResourceUrl", this.jwtService.getUserResourceUrl() + element.flag1)
            });
            // this.pdfSrcs.push( "../../../../../../assets/Lodop.pdf");
            // this.pdfSrcs.push( "../../../../../../assets/play.pdf");


            this.validateForm.controls.sn.patchValue("");
            this.pdfSrc = this.pdfSrcs[this.pdfIndex];
            this.showPdf = true;
          }

        } else {
          this.message.create('error', data.data.msg);
        }


      }
    );

  }

  initFrom() {
    this.validateForm = this.fb.group({
      sn: [null, [Validators.required]]
    });
  }
  zoom = 1.0;
  incrementZoom(amount) {
    if (this.showPdf)
      this.zoom += amount;
  }
  //导出功能
  export(type) {
    const expand = type == 'expand' ? true : false;
    this.nzGroupTr.forEach(line => {
      line.forEach(column => {
        if (this.columnData[column.columnName]['nzExpand']['nzUsed']) {
          this.expand(column.columnName, expand)
        }
      });
    });
    setTimeout(() => {
      console.log("exportTable", document.getElementById('exportTable'), XLSX.utils.table_to_sheet(document.getElementById('exportTable')))
      XLSX.writeFile(XLSX.utils.table_to_book(document.getElementById('exportTable')), 'SheetJS3.xlsx');

    }, 100);
  }

  //=======================================第二种导出
  indexToColName(index: number): string {
    if (index < 0) {
      return null;
    }
    let num = 65;// A的Unicode码
    let colName = "";
    do {
      if (colName.length > 0) {
        index--;
      }
      let remainder = index % 26;
      colName = String.fromCharCode(remainder + num) + colName;
      index = parseInt(((index - remainder) / 26) + '');
    } while (index > 0);
    return colName;
  }

  getHeadForExport(sheet, excelData) {

    // console.log("excelData", excelData)

    //1.填充表头-未合并状态
    this.exportHead.forEach(element => {
      for (let index = 0; index < this.exportHeadLength.width; index++) {
        element.push("");
      }
    });

    //2.更加表头数据，填充表头内容并合并单元格
    const merges = excelData['!merges'];
    let count = 1;
    merges.forEach(mergesData => {
      let isbreak = false;
      // console.log("mergesData", count++, mergesData);
      for (let i = mergesData.s.r; i <= mergesData.e.r; i++) {
        for (let j = mergesData.s.c; j <= mergesData.e.c; j++) {
          const char = this.indexToColName(j);
          // console.log("char", i, j, char + '' + (i + 1), excelData[char + '' + (i + 1)]);
          if (typeof excelData[char + '' + (i + 1)] != "undefined" && excelData[char + '' + (i + 1)] != '') {
            // console.log("value", i, j, excelData[char + '' + (i + 1)]['v']);
            this.exportHead[i][j] = excelData[char + '' + (i + 1)]['v'];
            isbreak = true
            break;
          }

        }
        if (isbreak) break;
      }



    });
    //合并
    sheet.getRow(1).values = this.exportHead[0];
    sheet.getRow(2).values = this.exportHead[1];
    merges.forEach(mergesData => {
      const mergesChar1 = this.indexToColName(mergesData.s.c);
      const mergesChar2 = this.indexToColName(mergesData.e.c)
      // console.log("mergesChar2",mergesData.s.c,mergesData.s.r,mergesData.e.c,mergesData.e.r);
      if (mergesChar1 != mergesChar2 || mergesData.s.r != mergesData.e.r) {
        sheet.mergeCells(mergesChar1 + (mergesData.s.r + 1) + ':' + mergesChar2 + (mergesData.e.r + 1))
      }
    });

  }

  addWipTotalDatas() {
    let length = this.listOfDisplayData.length;
    //添加汇总 
    let otherKeys = ["PROJECT_CODE", "PRODUCT_CODE", "WO_CODE", "LEADTIME", "START", "WORKFLOW_NAME"];
    let PROJECTTotal = JSON.parse(JSON.stringify(this.listOfDisplayData[0]));
    let PRODUCTTotal = JSON.parse(JSON.stringify(this.listOfDisplayData[0]));
    let lastPROJECT = this.listOfDisplayData[0]['PROJECT_CODE'], lastPRODUCT = this.listOfDisplayData[0]['PRODUCT_CODE'];
    for (let index = 1; index < length; index++) {
      const element = this.listOfDisplayData[index];
      let jumpIndex = 0;//插入数据后，index前进的数量

      if (lastPRODUCT === element['PRODUCT_CODE']) {
        //汇总产品
        for (const key in element) {
          if (element.hasOwnProperty(key) && otherKeys.indexOf(key) === -1) {
            PRODUCTTotal[key] = PRODUCTTotal[key] + element[key];
          }
        }
      } else {
        //新产品
        jumpIndex++;
      }

      if (lastPROJECT === element['PROJECT_CODE']) {
        //汇总项目
        for (const key in element) {
          if (element.hasOwnProperty(key) && otherKeys.indexOf(key) === -1) {
            PROJECTTotal[key] = parseInt(PROJECTTotal[key]) + parseInt(element[key]);
          }
        }
      } else {
        //新项目
        jumpIndex++;
      }
      lastPROJECT = element['PROJECT_CODE'];
      lastPRODUCT = element['PRODUCT_CODE'];
      console.log("jumpIndex", index, jumpIndex, element['PROJECT_CODE'], element['PRODUCT_CODE'])
      length = length + jumpIndex;
      if (jumpIndex > 0) {
        PRODUCTTotal['PRODUCT_CODE'] = PRODUCTTotal['PRODUCT_CODE'] + ' Total';
        PRODUCTTotal['WO_CODE'] = '';
        PRODUCTTotal['LEADTIME'] = '';
        PRODUCTTotal['START'] = '';
        PRODUCTTotal['WORKFLOW_NAME'] = '';
        this.listOfDisplayData.splice(index, 0, PRODUCTTotal);
        index++;
        PRODUCTTotal = JSON.parse(JSON.stringify(this.listOfDisplayData[index]));
      }
      if (jumpIndex > 1) {
        PROJECTTotal['PROJECT_CODE'] = PROJECTTotal['PROJECT_CODE'] + ' Total';
        PROJECTTotal['PRODUCT_CODE'] = '';
        PROJECTTotal['WO_CODE'] = '';
        PROJECTTotal['LEADTIME'] = '';
        PROJECTTotal['START'] = '';
        PROJECTTotal['WORKFLOW_NAME'] = '';
        this.listOfDisplayData.splice(index, 0, PROJECTTotal);
        index++;
        PROJECTTotal = JSON.parse(JSON.stringify(this.listOfDisplayData[index]));
      }
      if (length === index + 1) {
        PRODUCTTotal['PRODUCT_CODE'] = PRODUCTTotal['PRODUCT_CODE'] + ' Total';
        PRODUCTTotal['WO_CODE'] = '';
        PRODUCTTotal['LEADTIME'] = '';
        PRODUCTTotal['START'] = '';
        PRODUCTTotal['WORKFLOW_NAME'] = '';
        this.listOfDisplayData.splice(index + 1, 0, PRODUCTTotal);
        PROJECTTotal['PROJECT_CODE'] = PROJECTTotal['PROJECT_CODE'] + ' Total';
        PROJECTTotal['PRODUCT_CODE'] = '';
        PROJECTTotal['WO_CODE'] = '';
        PROJECTTotal['LEADTIME'] = '';
        PROJECTTotal['START'] = '';
        PROJECTTotal['WORKFLOW_NAME'] = '';
        this.listOfDisplayData.splice(index + 2, 0, PROJECTTotal);
      }

    }
    console.log('listOfDisplayData', this.listOfDisplayData)
  }
  isNewData = true;
  /**
   * 获取数据后导出
   */

  exportExcel(eventData) {
    //  获取搜索条件
    let searchMap = this.getSearchMapBylayout(eventData.layoutid);

    this.loading = true;
    this.searchData(true, searchMap, { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, eventData);


  }
  getSearchMapBylayout(layoutid) {
    if (layoutid != '') {
      const formData = this.setService.pageDatas['form_data_' + layoutid];
      const form = this.setService.pageDatas['form_' + layoutid];
      console.log("formdata", formData, layoutid)
      if (formData != undefined) {
        return this.formControlService.getSearchBodyT(formData, form)[0][this.blockid];
      } else {
        return this.searchMap;
      }
    } else {
      return this.searchMap;
    }
  }
  export2() {

    if (this.listOfDisplayData.length == 0) {
      this.message.create('error', `没有数据，请先搜索`);
      return;
    }
    if (this.isNewData) {
      this.addWipTotalDatas();
      this.isNewData = false;
    }


    const workbook = new Excel.Workbook();
    // let workbook = new Workbook();
    let sheet = workbook.addWorksheet('WIP报表')


    const expand = true;
    this.nzGroupTr.forEach(line => {
      line.forEach(column => {
        if (this.columnData[column.columnName]['nzExpand']['nzUsed']) {
          this.expand(column.columnName, expand)
        }
      });
    });
    setTimeout(() => {
      //利用sheetjs获取页面表头的合并情况
      const excelData = XLSX.utils.table_to_sheet(document.getElementById('exportTable'));
      this.getHeadForExport(sheet, excelData)

      //设置样式
      //设置样式-1自动宽度
      for (let index = 0; index <= 3; index++) {
        if (this.listOfDisplayData.length > index) {
          const data = this.listOfDisplayData[index]
          this.exportHeadJsonList.forEach(element => {
            //先算表头长度
            if (this.columnData[element.key].showLength > element.width - 2) {
              element.width = this.columnData[element.key].showLength + 5;
            }
            //算内容长度
            if (data[element.key]) {
              if (data[element.key].length > element.width - 2) {
                element.width = data[element.key].length + 5;
              }
            }
          });
        } else {
          break;
        }
      }

      sheet.columns = this.exportHeadJsonList;
      sheet.addRows(this.listOfDisplayData);
      // 设置样式-2对齐字体
      for (let index = 1; index <= sheet.rowCount; index++) {
        const row = sheet.getRow(index);
        row.eachCell((cell, rowNumber) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        })
        sheet.getRow(index).alignment = { vertical: 'middle', horizontal: 'center' }
        // sheet.getRow(index).border = {
        //   top: { style: 'thin' },
        //   left: { style: 'thin' },
        //   bottom: { style: 'thin' },
        //   right: { style: 'thin' }
        // };
        if (index <= this.exportHeadLength.height) {
          sheet.getRow(index).font = { size: 9, name: '微软雅黑', bold: true }
        } else {
          sheet.getRow(index).font = { size: 9, name: '微软雅黑' }
        }
        //分级
        if (index > 2) {
          if (sheet.getRow(index).getCell(2).value === '') {
          }
          else if (sheet.getRow(index).getCell(3).value === '') {
            console.log('outlineLevel2', index, sheet.getRow(index));
            sheet.getRow(index).outlineLevel = 1;
          }
          else {
            console.log('outlineLevel1', index, sheet.getRow(index));
            sheet.getRow(index).outlineLevel = 2;
          }
        }

      }


      console.log("sheet-data", sheet, sheet.rowCount)
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fs.saveAs(blob, 'WIP-' + this.generalPipe.transform(new Date(), 'date', 'yyyy-MM-dd HH:mm:ss') + '.xlsx');
        this.message.create('success', `生成成功，请下载。`);
      })
    }, 100);


  }

  //=======================================第二种导出end

}
